import axios from "axios";
const axiosService = axios.create({
  //baseURL: "https://localhost:44308/",
  baseURL: "http://happytable-api.com:31089/",
});

// 로그인
function loginUser(userData) {
  const url = `act/login`;
  return axiosService.post(url, userData);
}

// 공지사항 글쓰기
function fileUpload(formData) {
  const url = `notice/upload`;
  return axiosService.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 공지사항 목록
function getNoticeList() {
  const url = `notice/list`;
  return axiosService.get(url);
}

// 공지사항 글 보기
function getArticleDetail(key) {
  const url = `notice/detail`;
  return axiosService.get(url, {params: {key: key}});
}
// 공지사항 삭제
function getArticleDelete(key) {
  const url = `notice/delete`;
  return axiosService.post(url, key);
}

export {
  loginUser,
  fileUpload,
  getNoticeList,
  getArticleDetail,
  getArticleDelete,
};
